import { DeleteActionPath } from './DeleteActionPath';
import { DuplicateActionPath } from './DuplicateActionPath';
import { ReEvaluateActionPath } from './ReEvaluateActionPath';
import { SaveActionPath } from './SaveActionPath';
import { SaveActionPathNote } from './SaveActionPathNote';

/**
 * mutations
 *
 * @type {{SaveActionPath: ((function({}=): Promise<*>)|*), SaveActionPathNote: ((function({}=): Promise<*>)|*),
 *     ReEvaluateActionPath: ((function({}=): Promise<*>)|*), DuplicateActionPath: ((function({}=): Promise<*>)|*),
 *     DeleteActionPath: ((function({}=): Promise<*>)|*)}}
 */
export const mutations = {
  DeleteActionPath,
  DuplicateActionPath,
  ReEvaluateActionPath,
  SaveActionPath,
  SaveActionPathNote,
};
